import AuthorizationHelper from '@auth/services/authorization.helper';
import ModulesHelper from '@core/services/modules.helper';

export const walletAdminRoutes = [
  {
    path: 'wallets',
    name: 'admin-wallets',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.wallets],
      module: ModulesHelper.VIRTUAL_WALLET_MODULE_NAME,
    },
    component: () => import(/* webpackChunkName: "admin-wallets" */ '@wallet/pages/wallets.vue'),
  },
];
